const state = {};

const initGallery = () => {

	const gallery = document.querySelector('.gallery');
	if (gallery) {
		state.activeToggle = gallery.querySelector('.gallery__item--active');
		state.activeGallery = gallery.querySelector('.section-image--active');
		
		const galleryList = gallery.querySelector('.gallery__list');
		galleryList.addEventListener('click', (evt) => {
			if (evt.target.dataset.value && !evt.target.classList.contains('gallery__item--active')) {
				state.activeGallery.classList.remove('section-image--active');
				state.activeToggle.classList.remove('gallery__item--active');
				
				state.activeGallery = document.querySelector(`.gallery #${evt.target.dataset.value}`);
				state.activeGallery.classList.add('section-image--active');
				
				state.activeToggle = evt.target;
				state.activeToggle.classList.add('gallery__item--active');
			}
		});
	}
};

export default initGallery;
